/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import parsePhoneNumberFromString, { E164Number } from 'libphonenumber-js';
import { useForm } from 'react-hook-form';
import { Button } from '@sighten/beacon';

import { PhoneInput } from 'shared/components/inputs/PhoneInput/PhoneInput';
import { Name } from '../AccountBody/AccountBody.styles';
import { ContactInfoBodyHeader, ContentBody } from '../ContactInfoBody/ContactInfoBody.styles';

export interface IFormInput {
  phone_number: E164Number;
}

type Props = {
  phoneNumber: string;
  onSubmit: (formData: IFormInput) => void;
};

export function PhoneInputBody({ phoneNumber: phoneNumberProp, onSubmit }: Props) {
  const [isPhoneValid, setIsPhoneValid] = useState(Boolean(phoneNumberProp));

  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<IFormInput>({
    defaultValues: { phone_number: phoneNumberProp },
  });

  return (
    <ContentBody>
      <ContactInfoBodyHeader>
        <Name as="h3">{t('account.phoneNumber')}</Name>
      </ContactInfoBodyHeader>

      <form onSubmit={handleSubmit(onSubmit)}>
        <PhoneInput
          id="contact-form-phone"
          ariaLabel={t('account.phoneNumber')}
          label={t('account.phoneNumber')}
          showClearIcon
          onClearInput={() => {
            setValue('phone_number', '' as E164Number);
          }}
          onValidate={setIsPhoneValid}
          defaultValue={
            phoneNumberProp
              ? parsePhoneNumberFromString(phoneNumberProp, 'US')?.formatNational()
              : undefined
          }
          hasError={Boolean(errors.phone_number)}
          errorMessage={errors.phone_number?.message}
          margin="0 0 4px 0"
          {...register('phone_number', {
            required: t('account.invalidPhoneNumber'),
            validate: () => {
              if (!isPhoneValid) {
                return t('account.invalidPhoneNumber');
              }
              return true;
            },
          })}
        />

        <Button className="eb--mt-24" type="submit" isFullWidth>
          Save
        </Button>
      </form>
    </ContentBody>
  );
}

export default PhoneInputBody;
